import { ref } from 'vue';
import axios from 'axios';

// Configure axios
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Get CSRF token
const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

export function useStructureApi() {
  const loading = ref(false);
  const error = ref(null);
  
  async function loadStructure(id) {
    loading.value = true;
    error.value = null;
    
    try {
      const response = await axios.get(`/api/admin/ui/structures/${id}`);
      
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to load structure');
      }
    } catch (err) {
      error.value = err.message;
      console.error('Load structure failed:', err);
      alert('Failed to load structure: ' + err.message);
      return null;
    } finally {
      loading.value = false;
    }
  }
  
  async function saveStructure(id, data) {
    loading.value = true;
    error.value = null;
    
    try {
      const url = id 
        ? `/api/admin/ui/structures/${id}`
        : '/api/admin/ui/structures';
      
      const method = id ? 'put' : 'post';
      const response = await axios[method](url, data);
      
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to save structure');
      }
    } catch (err) {
      error.value = err.message;
      console.error('Save structure failed:', err);
      alert('Failed to save: ' + err.message);
      return null;
    } finally {
      loading.value = false;
    }
  }
  
  async function publishStructure(id) {
    loading.value = true;
    error.value = null;
    
    try {
      const response = await axios.post(`/api/admin/ui/structures/${id}/publish`);
      
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to publish structure');
      }
    } catch (err) {
      error.value = err.message;
      console.error('Publish structure failed:', err);
      alert('Failed to publish: ' + err.message);
      return null;
    } finally {
      loading.value = false;
    }
  }
  
  async function uploadImage(file) {
    loading.value = true;
    error.value = null;
    
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('type', 'image');
      
      const response = await axios.post('/api/admin/ui/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      if (response.data.success) {
        return response.data.data.url;
      } else {
        throw new Error(response.data.message || 'Failed to upload image');
      }
    } catch (err) {
      error.value = err.message;
      console.error('Upload image failed:', err);
      alert('Failed to upload image: ' + err.message);
      return null;
    } finally {
      loading.value = false;
    }
  }
  
  return {
    loading,
    error,
    loadStructure,
    saveStructure,
    publishStructure,
    uploadImage
  };
}

